import {
  get
} from 'jquery';
import {
  getData,
  postData,
  convertPageModel
} from './api-base.service'

export const getTeacherAccountCourseList = (teacherName, role) => {

  return getData('/TeacherCourse/GetTeacherAccountCourseList', {
    teacherName: teacherName || '',
    role: role || ''
  });
}

export const saveTeacherUser = (model) => {
  return postData('/TeacherCourse/SaveTeacherUser', model);
}

export const getTeacherViewModel = (id) => {
  return getData('/TeacherCourse/GetTeacherUser', {
    id: id
  });
}
export const getCurrentTeacher = () => {
  return getData('/TeacherCourse/GetCurrentTeacher');
}
export const getTeacherCourseList = (teacherId) => {
  return getData('/TeacherCourse/GetTeacherCourseList', {
    teacherId: teacherId
  });
}

export const getTeacherAllCourseList = (teacherId, getEnglishCourse) => {
  return getData('/TeacherCourse/GetTeacherAllCourseList', {
    teacherId: teacherId,
    getEnglishCourse: getEnglishCourse
  });
}
// export const saveTeacherCourse = (teacherId,list) => {
//     return postData(`/TeacherCourse/SaveTeacherCourse?teacherId=${teacherId}`, list);
// }
export const saveSetTeacherCourses = (teacherId, list) => {
  return postData(`/TeacherCourse/SaveSetTeacherCourses?teacherId=${teacherId}`, list);
}
export const getTeacherActiveCourses = (params) => {
  return getData("/TeacherCourse/GetTeacherActiveCourses");
}
export const activateCourse = (teacherId, courseId, campusId, hasSignIn, courseCategory) => {
  if (typeof hasSignIn == "undefined") {
    hasSignIn = true;
  }
  let data = {
    TeacherId: teacherId,
    CourseId: courseId,
    CampusId: null,
    HasSignIn: hasSignIn,
    IsOnline: false,
    courseCategory: courseCategory
  };
  if (!!campusId) {
    data["CampusId"] = campusId;
  }
  return postData(`/TeacherCourse/ActivateCourse`, data);
}

export const activateOnlineCourse = (teacherId, courseId, campusId, startTime, hours, classIntroduce, hasSignIn, courseCategory) => {
  let data = {
    TeacherId: teacherId,
    CourseId: courseId,
    CampusId: null,
    StartTime: startTime,
    Hours: hours,
    ClassIntroduce: classIntroduce,
    HasSignIn: hasSignIn,
    IsOnline: true,
    CourseCategory: courseCategory
  };
  if (!!campusId) {
    data["CampusId"] = campusId;
  }
  return postData(`/TeacherCourse/ActivateCourse`, data);
}

export const saveTeacherTrainingCourse = (model) => {

  return postData("/TeacherCourse/SaveTeacherTrainingCourse", model);
}
export const getTeacherTrainingActiveCourses = (params) => {
  var data = {
    teacherId: params && params.teacherId ? params.teacherId : "",
    categoryId: params.categoryId,
    termId: params.termId,
    termType: params.termType
  }

  return getData("/TeacherCourse/GetTeacherTrainingActiveCourses", data);
}

export const getCourseTeacherList = (courseId, campusId) => {
  return getData("/TeacherCourse/GetCourseTeacherList", {
    courseId: courseId,
    campusId: campusId
  });
}

export const getCourseActiveHistoryViewModelList = (courseId, campusId) => {
  return getData("/TeacherCourse/GetCourseActiveHistoryViewModelList", {
    courseId: courseId,
    campusId: campusId
  });
}

export const getCourseClassInLink = (courseActivationId) => {
  return getData("/TeacherCourse/GetCourseClassInLink", {
    courseActivationId: courseActivationId
  });
}



// WEBPACK FOOTER //
// ./src/service/teacherCourse.service.js